import { useEffect, useState } from "react";
import { ApolloProvider } from "@apollo/client";
import { WalletHook } from "./utils/ethereum";
import { woolBalance } from "./utils/wool";
import { useApollo } from "./utils/apollo";
import Page from "./Page";
import Modal from "react-modal";
import Menu from "./components/Menu";

import { ethers } from "ethers";
import Web3Modal from "web3modal";
import { InjectedConnector } from "@web3-react/injected-connector";
import WoolfAbi from "./utils/abi/woolf.abi";

const App = () => {
    const client = useApollo();

    const { wallet, chain } = WalletHook();
    const [wool, setWool] = useState("?");

    useEffect(() => {
        loadNFTs();
    }, []);

    async function loadNFTs() {
        /* create a generic provider and query for unsold market items */
        const provider = new ethers.providers.JsonRpcProvider("https://api.avax.network/ext/bc/C/rpc");
        const tokenContract = new ethers.Contract("0x904049EB1ed9799AfaF557ec80B8Bc4f1f40c0b8", WoolfAbi, provider);
        /*
         *  map over items returned from smart contract and format
         *  them as well as fetch their token metadata
         */
        let data;
        const minted = await tokenContract.minted();
        console.log(minted);
    }

    useEffect(() => {
        Modal.setAppElement("body");
    }, []);

    useEffect(() => {
        document.title = "Avax Wolf Game";
        const loadWool = async () => {
            if (!wallet) return;
            setWool(await woolBalance(wallet));
        };
        loadWool();
    }, [wallet, chain]);

    return (
        <ApolloProvider client={client}>
            <Page
                wallet={wallet}
                chain={chain}
                wool={wool}
                reload={async () => {
                    if (!wallet) return;
                    setWool(await woolBalance(wallet));
                }}
            />
        </ApolloProvider>
    );
};

export default App;
